<script>
  import { fly, fade } from "svelte/transition";
  // import  import { swipe } from "svelte-hammer";

  export let direction;
  export let bg;
  export let color = "rgba(0,0,0,.6)";
  export let showPane = false;
  export let overlay = false;
  export let closePane = () => (showPane = false);
  export let openPane = () => (showPane = true);
  let w = window.innerWidth;

</script>

{#if showPane}

    {#if overlay}
          <div class="overlay" style="background-color:{color}" on:click={closePane} transition:fade />
    {/if}

  <div class="pane" transition:fly={{ x: w, opacity: 1, duration:400 }}>
    <slot />
  </div>

  {/if}


<style>

  .overlay, .pane {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: var(--scrollbar);
        z-index:101;
  }

  .pane{
      background:white;
  }

</style>